import React, { useEffect, useMemo, useState } from 'react';
import WizardItem, { IWizardItem } from '../WizardItem';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import { useWizardContext } from '../../../Services/WizardContext';
import styles from './WizardCarousel.module.scss';
import WizardCarouselSlideIndicator from './WizardCarouselSlideIndicator/WizardCarouselSlideIndicator';

interface Props {
	item: IWizardItem;
}

const WizardCarousel: React.FC<Props> = ({ item }) => {
	const { activeScreenData } = useWizardContext();
	const [activeSlide, setActiveSlide] = useState<IWizardItem>();
	const [activeSlideIndex, setActiveSlideIndex] = useState<number>(0);

	const indicatorData: number[] = useMemo(() => {
		let index = 0;
		const temp: number[] = [];
		item.children?.forEach(child => {
			if (child.type === WizardItemType.DYNAMIC) {
				temp.push(index);
				index++;
			}
		});
		return temp;
	}, [item]);

	useEffect(() => {
		if (activeScreenData?.slideIndex) {
			setActiveSlideIndex(activeScreenData?.slideIndex);
		}
	}, [activeScreenData]);

	useEffect(() => {
		setActiveSlide(item.children?.[activeSlideIndex]);
	}, [activeSlideIndex]);

	const handleMoveForward = () => {
		setActiveSlideIndex(activeSlideIndex + 1);
	};

	const handleMoveBackward = () => {
		setActiveSlideIndex(activeSlideIndex - 1);
	};

	useEffect(() => {
		const keyPress = (e: any) => {
			if (e.keyCode === 37 && activeSlideIndex > 0) {
				handleMoveBackward();
			}
			if (
				e.keyCode === 39 &&
				item?.children?.length &&
				item.children.length - 1 > activeSlideIndex
			) {
				handleMoveForward();
			}
		};
		// @ts-ignore
		window.addEventListener('keydown', keyPress);
		// @ts-ignore
		return () => window.removeEventListener('keydown', keyPress);
	}, [activeSlideIndex]);

	return (
		<div className={styles.wrapper}>
			<div className={styles.content}>
				{activeSlideIndex > 0 ? (
					<div className={styles.leftArrow} onClick={handleMoveBackward} />
				) : (
					<div style={{ width: '30px' }} />
				)}
				<div className={styles.slideWrapper}>
					{activeSlide && (
						<WizardItem item={activeSlide} isCarouselChild={true} />
					)}
				</div>
				{item?.children?.length &&
				item.children.length - 1 > activeSlideIndex ? (
					<div className={styles.rightArrow} onClick={handleMoveForward} />
				) : (
					<div style={{ width: '30px' }} />
				)}
			</div>
			<div className={styles.navigation}>
				<WizardCarouselSlideIndicator
					indexes={indicatorData}
					activeIndex={activeSlideIndex}
					setActiveSlide={setActiveSlideIndex}
				/>
			</div>
		</div>
	);
};

export default WizardCarousel;
